var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled from 'styled-components';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-height: 100vh;\n"], ["\n  min-height: 100vh;\n"])));
var Topbar = styled.header(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: ", ";\n  position: fixed;\n  ", ";\n  ", ";\n  z-index: 2;\n\n  @media (max-width: 576px) {\n    left: 0px;\n    width: 100%;\n  }\n"], ["\n  height: ", ";\n  position: fixed;\n  ", ";\n  ", ";\n  z-index: 2;\n\n  @media (max-width: 576px) {\n    left: 0px;\n    width: 100%;\n  }\n"])), function (p) {
  return p.theme.topBarHeight;
}, function (p) {
  return p.theme.sidebarWidthAdjust('left', p);
}, function (p) {
  return p.theme.contentWidthAdjust('width', p);
});
var Sidebar = styled.section(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  height: ", ";\n  overflow-y: auto;\n  position: fixed;\n  top: 0;\n  ", ";\n  z-index: 1;\n\n  @media (max-width: 576px) {\n    display: none;\n    visibility: hidden;\n  }\n"], ["\n  height: ", ";\n  overflow-y: auto;\n  position: fixed;\n  top: 0;\n  ", ";\n  z-index: 1;\n\n  @media (max-width: 576px) {\n    display: none;\n    visibility: hidden;\n  }\n"])), function (p) {
  return p.theme.fullHeight;
}, function (p) {
  return p.theme.sidebarWidthAdjust('width', p);
});
var Content = styled.main(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  background-color: ", ";\n  height: ", ";\n  ", ";\n  overflow-y: auto;\n  position: fixed;\n  top: ", ";\n  //", ";\n  width: 100%;\n\n  @media (max-width: 576px) {\n    left: 0px;\n    width: 100%;\n  }\n"], ["\n  background-color: ", ";\n  height: ", ";\n  ", ";\n  overflow-y: auto;\n  position: fixed;\n  top: ", ";\n  //", ";\n  width: 100%;\n\n  @media (max-width: 576px) {\n    left: 0px;\n    width: 100%;\n  }\n"])), function (p) {
  return p.theme.level3;
}, function (p) {
  return p.theme.fullHeight;
}, function (p) {
  return p.theme.sidebarWidthAdjust('left', p);
}, function (p) {
  return p.theme.topBarHeight;
}, function (p) {
  return p.theme.contentWidthAdjust('width', p);
});

var Dashboard = function Dashboard(_a) {
  var children = _a.children,
      header = _a.header,
      sidebar = _a.sidebar;
  return React.createElement(Wrapper, {
    className: "dashboard"
  }, React.createElement(Topbar, {
    className: "dashboard-nav"
  }, header), React.createElement(Sidebar, {
    className: "dashboard-sidebar"
  }, sidebar), React.createElement(Content, {
    className: "dashboard-content"
  }, children));
};

export default Dashboard;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;